import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useCartData } from '../../CartPage/context/CartDataContext';
import Select from '@/v2/components/Select';
import { ComplexItemInfo } from './ComplexItemInfo';

export function ComplexPriceStep({ goNext }) {
  const { complexPrice, setComplexPrice, complex } = useCartData();
  const { state } = useLocation();

  const departmentIdFromState = state?.departmentId;

  useEffect(() => {
    if (!complexPrice && departmentIdFromState && complex?.prices?.length) {
      const matched = complex.prices.find(
        (p) =>
          String(p.medConsultDepartmentId) === String(departmentIdFromState),
      );

      if (matched) {
        setComplexPrice(matched);
        if (goNext) {
          goNext();
        }
      }
    }
  }, [complexPrice, departmentIdFromState, complex, setComplexPrice]);

  return (
    <div className="flex flex-col sm:flex-row sm:gap-4 w-full">
      {/* Form Column */}
      <div className="sm:w-2/3">
        <Select
          selected={complexPrice}
          onChange={(val) => {
            setComplexPrice(val.original);
            if (goNext) {
              goNext();
            }
          }}
          options={complex?.prices?.map((c) => ({
            label: c.departmentName,
            value: c.departmentId,
            original: c,
          }))}
          placeholder="Pasirinkite padalinį"
          className="w-full md:basis-1/3"
          allowNullOption={false}
        />
      </div>

      {/* Info Column */}
      <div className="sm:w-1/3 mt-6 sm:mt-0">
        <ComplexItemInfo price={complexPrice} />
      </div>
    </div>
  );
}
